export default __webpack_public_path__ + "static/media/formula.c68c8a01.png";